import { Component, Input } from '@angular/core';

const DEFAULT_ICON_SIZE = 16;

@Component({
  selector: 'app-spinner-icon',
  standalone: true,
  templateUrl: './spinner-icon.component.html',
  styleUrl: './spinner-icon.component.scss'
})
export class SpinnerIconComponent {
  @Input() size?: number = DEFAULT_ICON_SIZE;
  @Input() width?: number;
  @Input() height?: number;
}
